import Loading from "../../components/Loading/Loading";
import { useTranslation } from "react-i18next";

const ConfirmationModal = (props: {
    onStay: () => void;
    onCancel: () => void;
    isLoading: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <div className="modal">
            <div className="modal__background" onClick={props.onStay} />
            <div className="modal__card">
                <h3>{t("result.modalTitle")}</h3>
                <p>{t("result.modalDescription")}</p>
                <button
                    type="button"
                    className="primary-button"
                    onClick={props.onStay}
                >
                    {t("result.modalStay")}
                </button>
                <button
                    type="button"
                    className="secondary-button"
                    onClick={props.onCancel}
                >
                    {t("result.modalCancel")}
                </button>
                {props.isLoading && <Loading content={t("result.modalCanceling")} />}
            </div>
        </div>
    );
};

export default ConfirmationModal;
